import { Alert, Divider, Stack, Text } from 'braid-design-system';
import React from 'react';

import { useNotiHistory } from '../../HistoryContext.tsx';

import { HistoricNotiRow } from './components/HistoricNotiRow/HistoricNotiRow.tsx';
import { LoadingCard } from './components/LoadingCard/LoadingCard.tsx';

import { ScrollableCard } from '#src/components/ScrollableCard/ScrollableCard.tsx';

interface HistoryListProps {
  notiType: string;
}

export const HistoryList = ({ notiType }: HistoryListProps) => {
  const { notifications, loading, error } = useNotiHistory();

  if (error.failed) {
    return (
      <Alert tone="critical">
        <Stack space="small">
          <Text>We couldn’t load your recent notifications.</Text>
          <Text size="small">{error.message}</Text>
        </Stack>
      </Alert>
    );
  }
  if (loading) {
    return <LoadingCard />;
  }

  const notificationsFiltered =
    notiType === 'All Notifications'
      ? notifications
      : notifications.filter(({ noti }) => notiType === noti.title);

  const NotiRows = () => {
    if (notificationsFiltered.length === 0) {
      return <Text>No notifications in the last 30 days</Text>;
    }
    return (
      <ScrollableCard>
        <Stack space="medium">
          {notificationsFiltered.map((noti, i) => (
            <React.Fragment key={noti.scopedIdempotencyKey}>
              {i > 0 && <Divider />}
              <HistoricNotiRow noti={noti} key={noti.scopedIdempotencyKey} />
            </React.Fragment>
          ))}
        </Stack>
      </ScrollableCard>
    );
  };
  return <NotiRows />;
};
